module.exports = __webpack_public_path__ + "img/Image6.817970c8.png";